(function () {
  const U = window.UIX;
  const APP = window.APP;
  const Match = window.RB.Match;

  const el = U.el;
  const esc = U.esc;

  const MATCH_KEY = "riftbound-sim-match";

  function clone(x) {
    return JSON.parse(JSON.stringify(x));
  }

  function saveMatch() {
    if (APP.match && APP.match.online) return;
    try {
      if (APP.match) localStorage.setItem(MATCH_KEY, JSON.stringify(APP.match));
      else localStorage.removeItem(MATCH_KEY);
    } catch (e) { }
  }

  function restoreMatch() {
    let m = null;
    try {
      const raw = localStorage.getItem(MATCH_KEY);
      if (raw) m = JSON.parse(raw);
    } catch (e) { }
    if (!m || !m.registered || m.v !== 2) return null;
    APP.match = m;
    return m;
  }

  function clearMatch() {
    APP.match = null;
    APP.matchUi = null;
    APP.pregame = null;
    saveMatch();
  }

  function gameOfMatch(game) {
    const m = APP.match;
    if (!m || !game || !game.setup || !game.setup.match) return false;
    return !!m.setup && m.setup.seed === game.setup.seed;
  }

  function startMatch(match) {
    const live = APP.match;
    if (live && !live.online && Match.isMatch(live) && !live.over && live.games.length &&
      !confirm("Abandon the match in progress at " + Match.score(live) + "?")) return;
    APP.match = match;
    APP.matchUi = null;
    APP.pregame = null;
    saveMatch();
    prepStep();
  }

  function newUi(seat, handoff) {
    const m = APP.match;
    return {
      seat: seat,
      handoff: !!handoff,
      live: clone(m.live[seat]),
      note: null,
    };
  }

  function humanSeat(m, p) {
    return !m.ai[p];
  }

  function prepStep() {
    const m = APP.match;
    if (!m || m.over || !m.pending) return;
    U.startPregame();
  }

  function openSideDeck(seat) {
    const m = APP.match;
    const both = !m.online && humanSeat(m, 0) && humanSeat(m, 1);
    if (!APP.matchUi || APP.matchUi.seat !== seat) {
      APP.matchUi = newUi(seat, both && m.pending.ready[seat === 0 ? 1 : 0]);
    }
    saveMatch();
    APP.screen = "match";
    U.render();
  }

  function submitUi() {
    const m = APP.match;
    const ui = APP.matchUi;
    const problem = RB.Decklists.swapProblem(m.registered[ui.seat], ui.live);
    if (problem) { ui.note = problem; U.render(); return; }
    U.stagePregameDeck(ui.seat, clone(ui.live));
    APP.matchUi = null;
    U.startPregame();
  }

  function loadOnline(msg) {
    const mm = msg.match;
    const seat = msg.seat;
    const other = seat === 0 ? 1 : 0;
    const stub = { name: msg.names[other] || "Opponent", legend: null, champion: null, battlefields: [], runes: {}, deck: [], side: [] };
    const m = {
      v: 2,
      online: true,
      best: mm.best,
      gameNo: mm.gameNo,
      wins: mm.wins,
      choose: mm.designated === undefined ? null : mm.designated,
      names: msg.names,
      ai: [false, false],
      seed: 0,
      rng: 0,
      registered: [],
      live: [],
      presented: [],
      games: new Array(mm.wins[0] + mm.wins[1]).fill(null),
      over: mm.over,
      sideCount: mm.sideCount,
      pending: mm.phase === "turnOrder"
        ? { k: "turnOrder", game: mm.gameNo, bf: mm.bf, roll: mm.roll, designated: mm.designated, pick: mm.pick === undefined ? mm.best > 1 : mm.pick, first: mm.first }
        : { k: "present", game: mm.gameNo, ready: mm.ready.slice(), choice: [null, null] },
    };
    m.registered[seat] = msg.you.registered;
    m.registered[other] = stub;
    m.live[seat] = msg.you.live;
    m.live[other] = stub;
    m.presented[seat] = msg.you.presented;
    m.presented[other] = {};
    const sameGame = APP.match && APP.match.online && APP.match.gameNo === mm.gameNo;
    APP.match = m;
    APP.seat = seat;
    if (!sameGame) { APP.matchUi = null; APP.pregame = null; }
    if (mm.phase === "turnOrder") APP.matchUi = null;
    U.onlinePregame();
  }

  function recordFinished(state) {
    const m = APP.match;
    if (APP.net || !m || m.online || m.over || !APP.game || !gameOfMatch(APP.game) || !state.over) return;
    if (m.games.length && m.games[m.games.length - 1].setup.seed === APP.game.setup.seed) return;
    Match.recordGame(m, APP.game, state.over.winner);
    saveMatch();
  }

  function nextGame() {
    const m = APP.match;
    if (!m) return;
    if (m.over) { APP.screen = "menu"; APP.mode = "play"; U.render(); return; }
    prepStep();
  }

  function seatName(m, p) {
    return m.names[p] || (m.registered[p].name || "Player " + (p + 1)).split(" — ")[0];
  }

  function tally(deck) {
    const counts = {};
    const order = [];
    for (const id of deck) {
      if (counts[id] === undefined) { counts[id] = 0; order.push(id); }
      counts[id]++;
    }
    order.sort(function (x, y) {
      const cx = RB.Setup.findCard(x);
      const cy = RB.Setup.findCard(y);
      const ex = cx ? cx.energy || 0 : 0;
      const ey = cy ? cy.energy || 0 : 0;
      if (ex !== ey) return ex - ey;
      return (cx ? cx.name : x).localeCompare(cy ? cy.name : y);
    });
    return order.map(function (id) { return { id: id, n: counts[id] }; });
  }

  function swapsOf(registered, live) {
    const reg = {};
    for (const id of registered.deck || []) reg[id] = (reg[id] || 0) + 1;
    const now = {};
    for (const id of live.deck || []) now[id] = (now[id] || 0) + 1;
    let n = 0;
    for (const id in now) n += Math.max(0, now[id] - (reg[id] || 0));
    return n;
  }

  function moveCard(ui, id, from, to) {
    const src = ui.live[from];
    const i = src.lastIndexOf(id);
    if (i < 0) return;
    src.splice(i, 1);
    ui.live[to].push(id);
    if (to === "side" && ui.live.champion === id && ui.live.deck.indexOf(id) < 0) ui.live.champion = null;
    ui.note = null;
    U.render();
  }

  function cardRow(ui, entry, where) {
    const card = RB.Setup.findCard(entry.id);
    const row = el("div", "mtrow" + (ui.live.champion === entry.id ? " champ" : ""));
    row.appendChild(el("span", "msnum mtqty", String(entry.n)));
    const art = U.artImg(card, "mtart", { sizes: "60px" });
    row.appendChild(art);
    const name = el("span", "mtname", esc(card ? card.name : entry.id));
    row.appendChild(name);
    if (card && card.energy !== undefined && card.energy !== null) {
      row.appendChild(el("span", "mtcost msnum", String(card.energy)));
    }
    const move = el("button", "btn ghost small", where === "deck" ? "→ Side" : "→ Main");
    move.title = where === "deck"
      ? "Take one copy out of the main deck"
      : "Bring one copy into the main deck";
    move.onclick = function () { moveCard(ui, entry.id, where, where === "deck" ? "side" : "deck"); };
    row.appendChild(move);
    row.onclick = function (ev) {
      if (ev.target === move) return;
      moveCard(ui, entry.id, where, where === "deck" ? "side" : "deck");
    };
    return row;
  }

  function championRow(ui) {
    const wrap = el("div", "mtchamp");
    const champ = ui.live.champion ? RB.Setup.findCard(ui.live.champion) : null;
    wrap.appendChild(el("span", "mslbl", "Chosen champion"));
    const options = [];
    const seen = {};
    for (const id of ui.live.deck) {
      if (seen[id]) continue;
      seen[id] = true;
      const c = RB.Setup.findCard(id);
      if (RB.Decklists.isChampionUnit(c)) options.push(c);
    }
    if (!options.length) {
      wrap.appendChild(el("span", "mtwarn", "No champion unit left in the main deck."));
      return wrap;
    }
    for (const c of options) {
      (function (c) {
        const pick = el("button", "btn" + (champ && champ.id === c.id ? " primary" : " ghost") + " small", esc(c.name));
        pick.title = c.name + " — the champion starts in the champion zone (TR 403.4.a)";
        pick.onclick = function () { ui.live.champion = c.id; ui.note = null; U.render(); };
        wrap.appendChild(pick);
      })(c);
    }
    return wrap;
  }

  function sideSection(ui) {
    const m = APP.match;
    const sect = el("div", "mssect mtside");
    const problem = RB.Decklists.swapProblem(m.registered[ui.seat], ui.live);
    sect.appendChild(U.ribbon("Side deck",
      "Main " + ui.live.deck.length + "/" + RB.Decklists.DECK_SIZE + " · Side " + ui.live.side.length, "bbrib"));
    const cols = el("div", "mtcols");

    const mainCol = el("div", "mtcol");
    mainCol.appendChild(el("div", "mslbl", "Main deck — click a card to take it out"));
    const mainList = el("div", "mtlist");
    for (const entry of tally(ui.live.deck)) mainList.appendChild(cardRow(ui, entry, "deck"));
    mainCol.appendChild(mainList);
    cols.appendChild(mainCol);

    const sideCol = el("div", "mtcol");
    sideCol.appendChild(el("div", "mslbl", "Side deck — click a card to bring it in"));
    const sideList = el("div", "mtlist");
    const side = tally(ui.live.side);
    if (!side.length) sideList.appendChild(el("div", "msempty", "The side deck is empty."));
    for (const entry of side) sideList.appendChild(cardRow(ui, entry, "side"));
    sideCol.appendChild(sideList);
    cols.appendChild(sideCol);

    sect.appendChild(cols);
    sect.appendChild(championRow(ui));

    const foot = el("div", "mtfoot");
    const reset = el("button", "btn ghost small", "Reset to registered");
    reset.title = "Put the deck back the way it was registered for this match (TR 403.8)";
    reset.onclick = function () { ui.live = clone(m.registered[ui.seat]); ui.note = null; U.render(); };
    foot.appendChild(reset);
    const swaps = swapsOf(m.registered[ui.seat], ui.live);
    foot.appendChild(el("div", "mtnote" + (problem ? " bad" : " ok"), problem
      ? esc("⚠ " + problem)
      : esc(swaps ? swaps + " card" + (swaps === 1 ? "" : "s") + " swapped in — legal." : "Registered deck, nothing swapped.")));
    sect.appendChild(foot);
    return sect;
  }

  function renderHandoff(ui) {
    const m = APP.match;
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const wrap = el("div", "msui");
    wrap.id = "matchscreen";
    wrap.appendChild(el("div", "msweave"));
    const box = el("div", "mspane msbev mthand");
    const inner = el("div", "mspanein msbev");
    inner.appendChild(el("h1", "mtbig", esc(seatName(m, ui.seat))));
    inner.appendChild(el("div", "mslbl", "Pass the device — the other seat must not see these choices."));
    const go = el("button", "btn primary big", "I am " + esc(seatName(m, ui.seat)));
    go.onclick = function () { ui.handoff = false; U.render(); };
    inner.appendChild(go);
    box.appendChild(inner);
    wrap.appendChild(box);
    root.appendChild(wrap);
  }

  function renderMatchScreen() {
    const m = APP.match;
    if (!m) { APP.screen = "menu"; U.render(); return; }
    const ui = APP.matchUi;
    if (m.over || !m.pending || !ui) { renderResult(); return; }
    if (ui.handoff) { renderHandoff(ui); return; }

    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const wrap = el("div", "msui");
    wrap.id = "matchscreen";
    wrap.appendChild(el("div", "msweave"));

    const top = el("div", "mstop");
    top.appendChild(el("div", "mshair"));
    const leave = el("button", "btn bbback", "<span>Menu</span>");
    leave.title = "Leave this match";
    leave.onclick = function () {
      if (!confirm("Leave this match? The score is lost.")) return;
      if (m.online) { RB.Online.go("/play"); return; }
      clearMatch();
      APP.screen = "menu";
      APP.mode = "play";
      U.render();
    };
    top.appendChild(leave);
    const brand = el("div", "msbrand");
    brand.appendChild(el("h1", null, "GAME " + m.gameNo));
    brand.appendChild(el("div", "mslbl", esc(Match.label(m) + " · " + seatName(m, 0) + " " + Match.score(m) + " " + seatName(m, 1))));
    top.appendChild(brand);
    const acts = el("div", "mstopacts");
    acts.appendChild(el("div", "msseatlbl", esc(seatName(m, ui.seat))));
    top.appendChild(acts);
    wrap.appendChild(top);

    if (m.games.length) {
      wrap.appendChild(el("div", "mtlast", esc(
        "Game " + m.games.length + " went to " + seatName(m, m.choose === 0 ? 1 : 0) +
        " — the loser chooses who plays first (TR 407.4).")));
    }

    const body = el("div", "msbody mtbody solo");
    const col = el("div", "mspane msbev mtright");
    const inner = el("div", "mspanein msbev");
    inner.appendChild(sideSection(ui));
    col.appendChild(inner);
    body.appendChild(col);
    wrap.appendChild(body);

    const foot = el("div", "msgo");
    const problem = RB.Decklists.swapProblem(m.registered[ui.seat], ui.live);
    if (ui.note || problem) foot.appendChild(el("div", "msgonote bad", esc(ui.note || problem)));
    const go = el("button", "btn primary big", "Take it to the table");
    go.title = "Lock the side deck in, then present a battlefield at the table";
    go.disabled = !!problem;
    go.onclick = submitUi;
    foot.appendChild(go);
    wrap.appendChild(foot);
    root.appendChild(wrap);
  }

  function renderResult() {
    const m = APP.match;
    const root = document.getElementById("app");
    root.innerHTML = "";
    root.className = "";
    const wrap = el("div", "msui");
    wrap.id = "matchscreen";
    wrap.appendChild(el("div", "msweave"));
    const box = el("div", "mspane msbev mthand");
    const inner = el("div", "mspanein msbev");
    if (m.over) {
      inner.appendChild(el("h1", "mtbig", esc(seatName(m, m.over.winner) + " wins the match")));
      inner.appendChild(el("div", "mslbl", esc(Match.label(m) + " · " + Match.score(m))));
    } else {
      inner.appendChild(el("h1", "mtbig", esc("Game " + m.gameNo + " is under way")));
      inner.appendChild(el("div", "mslbl", esc(Match.label(m) + " · " + seatName(m, 0) + " " + Match.score(m) + " " + seatName(m, 1))));
    }
    const midGame = !m.pending && !m.over && APP.game && APP.game.setup && APP.game.setup.match;
    const go = el("button", "btn primary big", m.over ? "Back to the menu" : midGame ? "Back to the game" : "Continue");
    go.onclick = function () {
      if (m.over) { clearMatch(); APP.screen = "menu"; APP.mode = "play"; }
      else if (midGame) APP.screen = "game";
      else prepStep();
      U.render();
    };
    inner.appendChild(go);
    box.appendChild(inner);
    wrap.appendChild(box);
    root.appendChild(wrap);
  }

  function matchBar(state) {
    const m = APP.match;
    if (!m || !Match.isMatch(m) || !state.over || APP.net) return null;
    const bar = el("div", "mtbar");
    bar.appendChild(el("span", "msseatlbl", esc(seatName(m, 0) + " " + Match.score(m) + " " + seatName(m, 1))));
    if (m.over) {
      bar.appendChild(el("span", "mtnote ok", esc(seatName(m, m.over.winner) + " takes the match")));
      const done = el("button", "btn primary", "Match result");
      done.onclick = function () { APP.screen = "match"; U.render(); };
      bar.appendChild(done);
      return bar;
    }
    const go = el("button", "btn primary", "Game " + m.gameNo + " — side deck");
    go.title = "Sideboard, present a battlefield and play the next game of this match";
    go.onclick = function () { nextGame(); };
    bar.appendChild(go);
    return bar;
  }

  function matchChip() {
    const m = APP.match;
    if (!m || !Match.isMatch(m) || APP.net) return null;
    const chip = el("span", "seatchip", esc("GAME " + m.gameNo + " · " + Match.score(m)));
    chip.title = Match.label(m) + " — " + seatName(m, 0) + " " + Match.score(m) + " " + seatName(m, 1);
    return chip;
  }

  Object.assign(U, {
    renderMatchScreen: renderMatchScreen,
    openSideDeck: openSideDeck,
    matchPrepStep: prepStep,
    loadOnlineMatch: loadOnline,
    startMatch: startMatch,
    matchBar: matchBar,
    matchChip: matchChip,
    recordFinishedMatchGame: recordFinished,
    restoreMatch: restoreMatch,
    saveMatch: saveMatch,
    clearMatch: clearMatch,
  });
})();
